// extracted by mini-css-extract-plugin
export default {"root":"menu_trigger-module___root___fdc3e5d5","menu":"menu_trigger-module___menu___ab9be836"};